import React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import {
  getTransactionBillingAddress,
  getTransactionCreditMemoDetails,
} from "../../api/transaction-type";
import { slugMap } from "../../config/slug-config";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";

import CreditMemoItems from "./credit-memo/items";
import CreditMemoShipping from "./credit-memo/shipping";
import CreditMemoAccounting from "./credit-memo/accounting";
import CreditMemoRelationship from "./credit-memo/relationships";
import CreditMemoCommunication from "./credit-memo/communication";
import CreditMemoRelatedRecords from "./credit-memo/related-records";
import CreditMemoSystemInformation from "./credit-memo/system-information";
import CreditMemoCustom from "./credit-memo/custom";
import CreditMemoEft from "./credit-memo/eft";
import CreditMemoTaxReporting1 from "./credit-memo/tax-reporting1";
import CreditMemoCharges from "./credit-memo/charges";
import CreditMemoTaxReporting2 from "./credit-memo/tax-reporting2";
import CreditMemoAvaTax from "./credit-memo/ava-tax";
import { GridComp126, GridComp4 } from "../../components/GridComponents";
import { add } from "date-fns";

export default function TransactionTypeCreditMemo() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [linkingdocumentno, setlinkingdocumentno] = useState("");
  const [subTotal, setSubTotal] = useState("");
  const [discount, setDiscount] = useState("");
  const [gstHst, setGstHst] = useState("");
  const [pst, setPst] = useState("");
  const [total, setTotal] = useState("");
  const [billAddressData, setBillAddressData] = useState([]);
  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionDocCreditMemoDetailsData();
    }
  }, [user.token]);

  useEffect(() => {
    if (user.token) {
      getTransactionBillingAddressData();
    }
  }, [user.token]);

  async function getTransactionDocCreditMemoDetailsData() {
    setLoading(true);
    try {
      const { data } = await getTransactionCreditMemoDetails(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setlinkingdocumentno(data.data.linkingdocumentno);
      setSubTotal(data.data.subtotal);
      setDiscount(data.data.discount);
      setGstHst(data.data.gst_hst);
      setPst(data.data.pst);
      setTotal(data.data.total);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getTransactionBillingAddressData() {
    setLoading(true);
    try {
      const { data } = await getTransactionBillingAddress(user.token, {
        id: params.docNo,
      });
      setBillAddressData(data.data.data[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
    // setRowData([])
  }

  return loading ? (
    <>
      {
        <Typography component="h4" fontWeight={500} className="pageTitle">
        Credit Memo
      </Typography>
      /*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Address Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Address Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Sales Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Sales Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Credit Memo
      </Typography>
      <Typography component="h5" sx={{ mb: 2 }}>
        {/* {rowData?.map((d, i) => ( */}
        <span className="para-no">
          <strong>{rowData?.tranid}</strong> {rowData?.customer}
        </span>
        {/* ))} */}
        <Button className="blue-button" size="small" sx={{ ml: 1 }}>
          {rowData?.status}
        </Button>
      </Typography>
      {/*Primary Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <>
            <Grid container className="mb-2">
              <Grid item xs={12} sm={6} md={8}>
                <Grid container className="mb-2">
                  <GridComp4 title={"CREDIT #"} data={rowData?.credit_number} />
                  <GridComp4 title={"DATE"} data={rowData?.date} />
                  <GridComp4 title={"PO #"} data={rowData?.po} />
                  <GridComp4 title={"CUSTOMER"} data={rowData?.customer_id+" "+rowData?.customer} />
                  <GridComp4
                    title={"POSTING PERIOD"}
                    data={rowData?.posting_period}
                  />
                  <GridComp4 title={"JOB"} data={rowData?.job} />
                  <GridComp4 title={"MEMO"} data={rowData?.memo} />
                  <GridComp4 title={"PC/PROJECT"} data={rowData?.pc_project} />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Box className="viewBox">
                  <Box
                    className="headerItemsSB"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    pb={2}
                  >
                    <Typography
                      component="h5"
                      fontWeight={500}
                      className="pageHeading1"
                    >
                      Summary
                    </Typography>
                  </Box>
                  <Box className="viewDetilsBox1">
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">SUBTOTAL</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormtotal">{rowData?.subtotal}</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">TAX TOTAL</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormtotal">{rowData?.tax}</p>
                      </Grid>
                    </Grid>
                    <Divider />
                    <Grid container sx={{ mt: 1 }}>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormlabel">TOTAL</p>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} className="m-b-10">
                        <p className="tFormtotal">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(
                            parseFloat(
                              rowData?.subtotal?.replace(",", "") || "0"
                            ) + parseFloat(rowData?.tax || "0")
                          )}
                        </p>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </>
        </Box>
      </Box>
      {/*Sales Information*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Sales Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((d, i) => ( */}
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SALES REP</p>
              <p className="tFormName">{rowData?.sales_rep}</p>
            </Grid>

            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CREATED FROM</p>
              <p className="tFormName">{rowData?.created_from}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">LEAD SOURCE</p>
              <p className="tFormName">{rowData?.lead_source}</p>
            </Grid>
          </Grid>
          {/* ))} */}
        </Box>
      </Box>

      {/*Address Information*/}
      {/* <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Address Information
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {rowData?.map((d, i) => (
            <Grid container className="mb-2">
              <Grid item xs={12} sm={5} md={5}>
                <p className="tFormlabel">BILL TO</p>
                <p className="tFormName">{rowData?.bill_to}</p>
                <p className="tFormlabel">
                  <Link>Map</Link>
                </p>
              </Grid>
              <Grid item xs={12} sm={2} md={2}></Grid>
              <Grid item xs={12} sm={5} md={5}>
                <p className="tFormlabel">SHIP TO</p>
                <p className="tFormName">{rowData?.ship_to}</p>
                <p className="tFormlabel">
                  <Link>Map</Link>
                </p>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Box> */}

      {/*Classification*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Classification
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          {/* {rowData?.map((d, i) => ( */}
          <Grid container className="mb-2">
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SUBSIDIARY</p>
              <p className="tFormName">{rowData?.subsidiary}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">DEPARTMENT</p>
              <p className="tFormName">{rowData?.department}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SERVICE LINE</p>
              <p className="tFormName">{rowData?.service_line}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SUBMISSION ID</p>
              <p className="tFormName">{rowData?.submission_id}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SERVICE PERIOD</p>
              <p className="tFormName">{rowData?.service_period}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">SOURCE</p>
              <p className="tFormName">{rowData?.source}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel checkAndTextAlign">
                {rowData?.exclude_from_electronic_bank_payments_processing ===
                  "false" ||
                rowData?.exclude_from_electronic_bank_payments_processing ===
                  null ? (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label=""
                      />
                    </FormGroup>
                    DISABLE AVALARA TAX CALCULATION
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked disabled />}
                        label=""
                      />
                    </FormGroup>
                    DISABLE AVALARA TAX CALCULATION
                  </>
                )}
              </p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">LOCATION</p>
              <p className="tFormName">{rowData?.location}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CUSTOM DUTY AND IMPORT FEES</p>
              <p className="tFormName">{rowData?.custom_duty_fee}</p>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={4} className="m-b-10"></Grid> */}
            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">PROJECT ID</p>
              <p className="tFormName">{rowData?.project_id}</p>
            </Grid>
            <Grid item xs={12} sm={6} md={6} className="m-b-10">
              <p className="tFormlabel checkAndTextAlign">
                {rowData?.exclude_from_electronic_bank_payments_processing ===
                  "false" ||
                rowData?.exclude_from_electronic_bank_payments_processing ===
                  null ? (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox disabled />}
                        label=""
                      />
                    </FormGroup>
                    EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING
                  </>
                ) : (
                  <>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox checked disabled />}
                        label=""
                      />
                    </FormGroup>
                    EXCLUDE FROM ELECTRONIC BANK PAYMENTS PROCESSING
                  </>
                )}
              </p>
            </Grid>

            <Grid item xs={12} sm={6} md={4} className="m-b-10">
              <p className="tFormlabel">CUSTOMER ID</p>
              <p className="tFormName">{rowData?.customer_id}</p>
            </Grid>
          </Grid>
          {/* ))} */}
        </Box>
      </Box>

      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 460, sm: 620, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg"
          >
            <Tab label="Items" />
            <Tab label="Shipping" />
            <Tab label="Billing" />
            <Tab label="Accounting" />
            <Tab label="Relationships" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
            <Tab label="Ava Tax" />
          </Tabs>

          {/*Items*/}
          <TabPanel value={tabIndex} index={0}>
            <CreditMemoItems />
          </TabPanel>
          {/*Items*/}

          {/* Shipping */}
          <TabPanel value={tabIndex} index={1}>
          {tabIndex === 1 &&      <CreditMemoShipping tabIndexP={tabIndex} />}
          </TabPanel>

          {/* Billing */}
          <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              <Grid container className="mb-2">
                <Grid item xs={12} sm={12} md={12} className="m-b-10">
                  <p className="titleHeading m-0">BILLING ADDRESS</p>
                </Grid>
                <Grid container className="mb-2">
                  <Grid item xs={12} sm={6} md={6} className="m-b-10">
                    <p className="tFormlabel">BILL TO </p>
                    <p className="tFormName">
                      {billAddressData?.vendor}{" "}
                      <span style={{ color: "#0066b2" }}>Map</span>
                    </p>
                  </Grid>
                </Grid>

                {/* <CustomCheckBoxComp126
            title={"TAX DATE OVERRIDE"}
            data={rowData?.tax_date_override}
          />
          <GridComp126
            title={"AVATAX OVERRIDE DATE"}
            data={rowData?.avatax_override_date}
          /> */}
              </Grid>
            </Box>
          </TabPanel>

          {/* Accounting */}
          <TabPanel value={tabIndex} index={3}>
            {tabIndex === 3 && <CreditMemoAccounting tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Accounting */}

          {/* Relationship */}
          <TabPanel value={tabIndex} index={4}>
            {tabIndex === 4 && <CreditMemoRelationship tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Relationship */}

          {/* Communication */}
          <TabPanel value={tabIndex} index={5}>
            {tabIndex === 5 && <CreditMemoCommunication tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Communication */}

          {/* RelatedRecords */}
          <TabPanel value={tabIndex} index={6}>
            {tabIndex === 6 && (
              <CreditMemoRelatedRecords tabIndexP={tabIndex} />
            )}
          </TabPanel>
          {/* RelatedRecords */}

          {/* SystemInformation */}

          <TabPanel value={tabIndex} index={7}>
            {tabIndex === 7 && <CreditMemoSystemInformation />}
          </TabPanel>
          {/* SystemInformation */}

          {/* Custom */}
          <TabPanel value={tabIndex} index={8}>
            {tabIndex === 8 && <CreditMemoCustom tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Custom */}

          {/* Eft */}
          <TabPanel value={tabIndex} index={9}>
            {tabIndex === 9 && <CreditMemoEft tabIndexP={tabIndex} />}
          </TabPanel>
          {/* Eft */}

          {/* AvaTax */}
          <TabPanel value={tabIndex} index={10}>
            {tabIndex === 10 && <CreditMemoAvaTax tabIndexP={tabIndex} />}
          </TabPanel>
          {/* AvaTax */}
        </Box>
      </Box>
    </>
  );
}
